import { infiniteQueryOptions } from '@tanstack/react-query';

import { DashboardFilters, DashboardSorts, DashboardTab } from 'types/internal';
import {
  FetchDashboardSurveysResponse,
  fetchDashboardSurveys,
} from 'services/backend/dashboard';

export const dashboardQueries = {
  get: (opts: {
    activeTab: DashboardTab | undefined;
    filters: DashboardFilters;
    isAdmin: boolean;
    name: string;
    organizationId: number | undefined;
    sorts: DashboardSorts;
  }) =>
    infiniteQueryOptions({
      queryKey: [
        'dashboard',
        {
          activeTab: opts.activeTab,
          filters: opts.filters,
          isAdmin: opts.isAdmin,
          name: opts.name,
          organizationId: opts.organizationId,
          sorts: opts.sorts,
        },
      ],
      queryFn: ({ pageParam: offset }) => {
        return fetchDashboardSurveys({
          activeTab: opts.activeTab,
          filters: opts.filters,
          isAdmin: opts.isAdmin,
          limit: 20,
          name: opts.name,
          offset,
          organizationId: opts.organizationId,
          sorts: opts.sorts,
        });
      },
      initialPageParam: 0,
      getNextPageParam: (lastPage: FetchDashboardSurveysResponse) => {
        const { draftAmount, launchedAmount, nextOffset } = lastPage;
        const comparisonAmount =
          opts.activeTab === 'drafts' ? draftAmount : launchedAmount;

        return nextOffset >= comparisonAmount ? null : nextOffset;
      },
    }),
};
